module.exports = "import React from 'react';\n\nexport default class Example extends React.Component {\n  render() {\n    return (\n      <div style={{ padding: '24px' }}>\n        <p>As you scroll, examples will show here.</p>\n      </div>\n    );\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/sections/00-Start/App.js
// module id = 248
// module chunks = 0